export default class Checkbox {
  checkAll(element, childElement) {
    $(childElement).prop('checked', element.checked)
  }

  checkingAllButton(allElement, childElement) {
    $(allElement).prop('checked', $(childElement).length === $(`${childElement}:checked`).length)
  }
}
